export class FetchError extends Error {
    constructor(status, message) {
        super(`Error: ${message}`)
        this.name = "FetchError";
        this.status = status;
    }
}
